import React, { useEffect } from 'react';
import './OrdersListTab.css';
import { IoMdArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { formatTimestamp,Url } from '../../../Services/Api';




export default function OrdersListTab({item,items,oid,is_new,name,dateTime,total,status}) {
    const navigate = useNavigate();
    const handleView = (row) => {
        navigate("/E-Commerce/All-Orders/View-Orders", { state: row });
      };
    const formatPrice = (price) => {
        return new Intl.NumberFormat('en-us', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: price % 1 === 0 ? 0 : 2, // Show decimals only if necessary
          maximumFractionDigits: 2, // Limit to 2 decimal places
        }).format(price);
      };
    return(
        <div className='recent_order_tab'>
            <div className='images'>
                {
                    items && items.map((item)=>{
                        return (
                            <img src={`${Url}${item.image}`} />  
                        )
                    })
                }
            </div>
            <div className='order_details'>
                <h3>Order {oid}  {is_new === 1? <div className='is_new_order' >new</div> : <></>}
                </h3>
                <p>{name}</p>
                <p>{formatTimestamp(dateTime)}</p>
            </div>
            <div className='order_details_2'>
                <div className='section1'>
                    <p>{items?.length} Products</p>
                    <h3>{formatPrice(total)}</h3> 
                </div>  
                <div className='section2'>
                    <p>{status}</p>
                </div>  
                <div className='section3'>
                    <div className='openOrder' onClick={()=>{
                        handleView(item)
                    }}>
                        <IoMdArrowForward/>
                    </div>
                </div>  
            </div>
            
        </div>
    )
}